(() => {
  const rootUrl = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'CAD';
    const locale = document.documentElement.lang || 'fr-CA';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `${((Number(cents) || 0) / 100).toFixed(2)} $`;
    }
  };

  const updateHeaderCart = (count) => {
    document.querySelectorAll('.rc-cart').forEach((link) => {
      link.textContent = `Panier (${Number(count) || 0})`;
    });
  };

  const injectStyles = () => {
    if (document.getElementById('rc-cart-ux-styles')) return;
    const style = document.createElement('style');
    style.id = 'rc-cart-ux-styles';
    style.textContent = `
      .rc-product__add{transition:opacity .2s ease,transform .2s ease,background-color .2s ease,color .2s ease}
      .rc-product__add.rc-add-swap{opacity:.18;transform:scale(.975)}
      .rc-product__add.rc-add-success{background:#3f6547;border-color:#3f6547;color:#fff}
      .rc-product__add.rc-add-error{background:#8a4137;border-color:#8a4137;color:#fff}
      .rc-cart-page.rc-cart-updating{cursor:progress}
      .rc-cart-page .rc-cart-item.rc-line-updating{opacity:.62;transition:opacity .18s ease}
      .rc-cart-page input[name="updates[]"].rc-qty-error{border-color:#9b3f35!important;box-shadow:0 0 0 2px rgba(155,63,53,.12)}
    `;
    document.head.appendChild(style);
  };

  const swapButtonText = (button, text, className) => new Promise((resolve) => {
    button.classList.add('rc-add-swap');
    window.setTimeout(() => {
      button.textContent = text;
      button.classList.remove('rc-add-swap', 'rc-add-success', 'rc-add-error');
      if (className) button.classList.add(className);
      requestAnimationFrame(resolve);
    }, 170);
  });

  const handleProductSubmit = async (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form || !form.classList.contains('rc-product__form')) return;

    const button = event.submitter instanceof HTMLElement && event.submitter.matches('[data-rc-add]')
      ? event.submitter
      : null;
    if (!button) return;

    const personalization = form.querySelector('[data-rc-personalization]');
    if (personalization && !personalization.value.trim()) return;

    const imageInput = form.querySelector('[data-rc-image-input]');
    if (imageInput && (!imageInput.files || imageInput.files.length === 0)) return;

    if (!form.checkValidity()) return;

    event.preventDefault();
    if (button.dataset.rcAdding === 'true') return;

    button.dataset.rcAdding = 'true';
    const normalText = button.dataset.rcNormalText || button.textContent.trim() || 'Ajouter au panier';
    button.dataset.rcNormalText = normalText;
    button.disabled = true;

    try {
      const response = await fetch(`${rootUrl()}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin',
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || payload.status) {
        throw new Error(payload.description || payload.message || 'Impossible d’ajouter ce produit au panier.');
      }

      await swapButtonText(button, 'Ajouté au panier ✓', 'rc-add-success');

      try {
        const cartResponse = await fetch(`${rootUrl()}cart.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          updateHeaderCart(cart.item_count);
        }
      } catch (_) {}

      window.clearTimeout(Number(button.dataset.rcResetTimer || 0));
      const timer = window.setTimeout(async () => {
        await swapButtonText(button, normalText, '');
        button.disabled = false;
        delete button.dataset.rcAdding;
        delete button.dataset.rcResetTimer;
      }, 5000);
      button.dataset.rcResetTimer = String(timer);
    } catch (error) {
      console.error('[Rustique Chic] Ajout au panier:', error);
      await swapButtonText(button, 'Erreur — réessayer', 'rc-add-error');
      window.setTimeout(async () => {
        await swapButtonText(button, normalText, '');
        button.disabled = false;
        delete button.dataset.rcAdding;
      }, 2600);
    }
  };

  const syncCartDom = (page, cart) => {
    const rows = Array.from(page.querySelectorAll('.rc-cart-item'));
    const inputs = Array.from(page.querySelectorAll('input[name="updates[]"]'));

    if (rows.length !== cart.items.length) {
      window.location.reload();
      return;
    }

    cart.items.forEach((item, index) => {
      const row = rows[index];
      const input = inputs[index];
      const linePrice = row?.querySelector('.rc-cart-item__info > strong');
      if (linePrice) linePrice.textContent = money(item.final_line_price);
      if (input) {
        input.value = String(item.quantity);
        input.dataset.rcCurrentQuantity = String(item.quantity);
        input.classList.remove('rc-qty-error');
      }
      row?.classList.remove('rc-line-updating');
    });

    const total = page.querySelector('.rc-cart-summary > strong');
    if (total) total.textContent = money(cart.total_price);
    updateHeaderCart(cart.item_count);
    document.dispatchEvent(new CustomEvent('rc-cart-updated',{detail:{cart}}));
  };

  const updateCartQuantity = async (page, input) => {
    const inputs = Array.from(page.querySelectorAll('input[name="updates[]"]'));
    const line = inputs.indexOf(input) + 1;
    if (line <= 0) return;

    const previous = Number(input.dataset.rcCurrentQuantity || input.defaultValue || 0);
    const quantity = Math.max(0, Math.floor(Number(input.value)));
    if (!Number.isFinite(quantity)) {
      input.value = String(previous);
      return;
    }
    if (quantity === previous) return;

    const row = input.closest('.rc-cart-item');
    row?.classList.add('rc-line-updating');
    page.classList.add('rc-cart-updating');
    input.disabled = true;

    try {
      const response = await fetch(`${rootUrl()}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ line, quantity }),
        credentials: 'same-origin',
      });
      const cart = await response.json().catch(() => ({}));
      if (!response.ok || cart.status) {
        throw new Error(cart.description || cart.message || 'Impossible de modifier la quantité.');
      }

      if (quantity === 0 || !cart.items?.length) {
        window.location.reload();
        return;
      }

      syncCartDom(page, cart);
    } catch (error) {
      console.error('[Rustique Chic] Mise à jour du panier:', error);
      input.value = String(previous);
      input.classList.add('rc-qty-error');
      row?.classList.remove('rc-line-updating');
    } finally {
      input.disabled = false;
      page.classList.remove('rc-cart-updating');
    }
  };

  const initCartPage = (page) => {
    if (!page || page.dataset.rcCartUx === 'true') return;
    page.dataset.rcCartUx = 'true';

    const timers = new WeakMap();
    page.querySelectorAll('input[name="updates[]"]').forEach((input) => {
      input.dataset.rcCurrentQuantity = input.value;
      const controls=input.closest('.rc-v22-qty');
      if(controls)controls.querySelectorAll('[data-rc-qty-change]').forEach((btn)=>{
        btn.addEventListener('click',()=>{
          if(input.disabled)return;
          input.value=String(Math.min(30,Math.max(1,Number(input.value||1)+Number(btn.dataset.rcQtyChange||0))));
          input.dispatchEvent(new Event('change',{bubbles:true}));
        });
      });

      const schedule = (delay) => {
        const oldTimer = timers.get(input);
        if (oldTimer) window.clearTimeout(oldTimer);
        const timer = window.setTimeout(() => updateCartQuantity(page, input), delay);
        timers.set(input, timer);
      };

      input.addEventListener('input', () => schedule(500));
      input.addEventListener('change', () => schedule(0));
    });

    const refreshButton = page.querySelector('button[name="update"]');
    if (refreshButton) {
      refreshButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        window.location.reload();
      });
    }

    const continueLink = page.querySelector('.rc-cart-summary > a');
    if (continueLink) continueLink.href = `${rootUrl()}?category=all#collection`;
  };

  const init = () => {
    injectStyles();
    const cartPage = document.querySelector('.rc-cart-page');
    if (cartPage) initCartPage(cartPage);
  };

  document.addEventListener('submit', handleProductSubmit, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
